import * as React from 'react';
import './App.css';

function App() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-blue-500 to-purple-600">
      <main className="text-center text-white p-8 max-w-2xl">
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 shadow-xl">
          <img
            src="/NewMMLogo_Transparent_NoBuffer.png"
            alt="Minimenu AI System Logo"
            className="logo mx-auto mb-8 rounded-full bg-white/20 p-4" // Applied custom class
          />
          <h1 className="text-5xl font-bold mb-4">Coming Soon</h1>
          <p className="text-xl mb-8">
            Minimenu AI System is under construction. We're working hard to bring you an innovative AI experience.
          </p>
          <form className="flex flex-col sm:flex-row justify-center items-center gap-4">
            <input
              type="email"
              placeholder="Enter your email"
              className="px-4 py-3 w-full sm:w-64 text-gray-900 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300 bg-white/90"
              required
            />
            <button
              type="submit"
              className="w-full sm:w-auto px-8 py-3 bg-yellow-400 text-gray-900 rounded-lg hover:bg-yellow-300 transition-colors duration-300 font-semibold shadow-lg hover:shadow-xl"
            >
              Notify Me
            </button>
          </form>
          <p className="mt-4 text-sm opacity-75">
            We'll let you know when we're ready to launch!
          </p>
        </div>
      </main>
    </div>
  );
}

export default App;
